import { RG_TYPE as o } from "@project-rouge/rg-core";
import { VisibilityPreset as r } from "./index.js";
const i = {
  [r.architecture]: [
    o.Ceiling,
    o.Floor,
    o.Wall,
    o.Window,
    o.Door,
    o.Facade,
    o.Roof,
    o.Parapet,
    o.Glazing
  ],
  [r.abstract]: [
    o.Module,
    o.Core,
    o.Corridor,
    o.Entrance,
    o.EmptySpace
  ],
  [r.openings]: [
    o.Door,
    o.Window
  ],
  [r.modules]: [
    o.Module,
    o.Core,
    o.Corridor
  ],
  [r.apartments]: [
    o.Apartment
  ],
  [r.rooms]: [
    o.Room
  ],
  [r.custom]: []
};
export {
  i as VisibilityPresets
};
//# sourceMappingURL=index3.js.map
